// extracted by mini-css-extract-plugin
module.exports = {"about":"style_about__2tjQP","info":"style_info__ITlJz","infoModal":"style_infoModal__2npbQ"};